import { trigger, style, transition, animate, state } from "@angular/animations";
import {
	Component,
	ViewEncapsulation,
	Input,
	EventEmitter,
	forwardRef,
	Output,
	ElementRef,
	ViewChild,
	OnDestroy,
	ChangeDetectorRef,
	ÉµÉµsetComponentScope,
	Self,
	Optional
} from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NgControl } from "@angular/forms";
import { IdService } from "../shared/services/id.service";
import { isMobile } from "../shared/utils/mobile";
@Component({
	selector: "rbc-dropdown",
	templateUrl: "./dropdown.component.html",
	encapsulation: ViewEncapsulation.None,
	styles: [],
	animations: [
		trigger('toggleCard', [
			state('true', 
				style({
					height: '*'
				})
			),
			state('false', 
				style({
					height: 0,
					visibility: 'hidden',
					overflow: 'hidden'
				})
			),
			state('void', 
				style({
					height: 0,
					visibility: 'hidden',
					overflow: 'hidden'
				})
			),
			transition('true <=> *', animate('0.4s ease-in-out'))
		])
	]
})
export class DropdownComponent implements ControlValueAccessor, OnDestroy {
	@Input() options;
	@Input() disabled = false;
	@Input() height = "200px";
	@Input() helpText: string;
	@Input() id: string;
	@Input() label: string;
	@Input() status: string;
	@Input() statusType: string;
	@Input() size: string;
	@Input() sizeWidth: string;
	@Input() ariaLabel: string;
	@Input() ariaLabelledby: string;
	@Input() ariaDescribedby: string;
	@Input() ariaActiveDescendant: string;
	@Input() labelSrOnly;

	@Output() selectUpdate = new EventEmitter<any>();
	clickListener = this.$_Dropdown_close.bind(this);
	activeTransition = "max-height"

	public value: string;
	public isDisabled: boolean;
	open = false;
	typed = "";
	selectedLabel: string;
	index = 0;
	highlightID: string;
	activeIndex: number = 0;

	@Input() defaultText = "Select Item";
	@ViewChild("cardResults", { static: false, read:ElementRef }) cardResults;
	@ViewChild("cardResults", { static: false }) cardResultsList: ElementRef;
	@ViewChild("cardList", { static: false }) cardList: ElementRef;

	@ViewChild("optionsRef", { static: false }) optionsRef: ElementRef;
	@ViewChild("dropdown", { static: false }) dropdown: ElementRef;


	constructor(private idService: IdService, private cdr: ChangeDetectorRef, @Optional() @Self() private controlDirective: NgControl) {
		this.id = this.id ? this.id : this.idService.generate();
		if(this.controlDirective){
			controlDirective.valueAccessor = this;
		}
	}

	ngOnInit(){
		this.processValue();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
		document.removeEventListener("click", this.clickListener);
	}

	// Function to call when the rating changes.
	onChange = (item) => { };
	// Function to call when the input is touched (when a star is clicked).
	onTouched = () => { };

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	isMobileHandler(): boolean {
		return isMobile();
	}

	setDisabledState(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
	}

	writeValue(value: any): void {
		this.value = value;
		this.processValue();

	}

	onBlur(e) {
		if (this.open) {
			this.open = false;
			this.onTouched();
		}
	}

	clickOutside(e) {
		if (e.target.id !== this.id) {
			this.open = false;
			document.removeEventListener("click", this.clickListener);
		} else {
			this.open = true;
		}
	}

	selectItem(item): void {
		this.onChange(item);
		this.value = item;
		this.processValue();
		this.selectUpdate.emit(item);
		this.open = false;
	}

	$_SelectDropdown_open(e) {
		const key = e.key && e.key.toLowerCase();
		if (!key || (key && (key.indexOf('down') > -1 || key.indexOf('up') > -1 || key === 'enter' || key === ' '))) {

			let newStatus = !this.open;
			this.open = newStatus && !this.disabled;
			if (this.open) {
				setTimeout(() => {
					this.cardList.nativeElement.focus();
				});
			}
			['click', 'touchend', 'keydown'].forEach(handler => document.addEventListener(handler, this.clickListener));
		}
	}

	$_Dropdown_close(e) {
		if ((e.target.id != this.dropdown.nativeElement.id && e.target.id != this.cardList.nativeElement.id  )|| (typeof e.key != 'undefined' && (e.key.toLowerCase() === 'escape'  || e.key.toLowerCase() === 'enter'))) {
			this.open = false;
			this.cdr.detectChanges();
			['click', 'touchend', 'keydown'].forEach(handler => document.removeEventListener(handler, this.clickListener));
			document.getElementById(this.id).focus();
		}
	}


	$_Dropdown_updateHighlight(e) {
		const key = e.key.toLowerCase();

		// prevents main button from triggering click event when focus is moved to it
		// but don't disable tab key press
		if (key.toLowerCase() !== 'tab') {
			e.preventDefault();
		}

		if (
			!this.isMobileHandler() &&
			this.options.length > 0 &&
			this.open &&
			(e.which && /[a-zA-Z]/g.test(String.fromCharCode(e.which)))
		) {
			this.typed += key;

			const matchedIndex = this.options.findIndex(option => option.label.toLowerCase().startsWith(this.typed));
			if (matchedIndex > -1) {
				this.activeIndex = matchedIndex;
				const options = this.cardResultsList['cardResults'].nativeElement;
				const activeOption = this.optionsRef[this.activeIndex];
				options.scrollTop = activeOption.offsetTop;
			}
		}

		setTimeout(() => {
			this.typed = "";
		}, 2000);

		this.$_SelectDropdown_updateHighlight(e);
	}

	$_SelectDropdown_nextEligibleOption(index, options, nbOptions) {
		let nextIndex = index + 1;
		while (nextIndex < nbOptions && options[nextIndex].disabled) {
			nextIndex += 1;
		}
		// if next index was not past end return it else return original
		return nextIndex !== nbOptions ? nextIndex : index;
	}

	$_SelectDropdown_previousEligibleOption(index, options) {
		let nextIndex = index - 1;
		while (nextIndex > -1 && options[nextIndex].disabled) {
			nextIndex -= 1;
		}
		// if next index was not past end return it else return original
		return nextIndex > -1 ? nextIndex : index;
	}

	$_SelectDropdown_updateHighlight(e) {
		const key = e.key.toLowerCase();
		const nbOptions = this.options.length;
		let options: any;
		let activeOption :any ;
		let optionsList;
		if (nbOptions > 0 && this.open) {
			// if key press down
			if (key.indexOf('down') > -1 || key.indexOf('up') > -1) {
				options = this.cardResults.nativeElement;
				optionsList = this.cardResultsList['cardResults'].nativeElement;
				activeOption = optionsList.querySelector('.active');
			}

			if (key.indexOf("down") > -1) {
				e.preventDefault();
				this.index = this.$_SelectDropdown_nextEligibleOption(
					this.index,
					this.options,
					nbOptions
				);

				this.highlightID = this.options[this.index].id;
				this.activeIndex = this.index;

				if (activeOption) {
					options.scrollTop = activeOption.offsetTop;
				}
			} else if (key.indexOf("up") > -1) {
				e.preventDefault();
				this.index = this.$_SelectDropdown_previousEligibleOption(
					this.index,
					this.options
				);
				this.highlightID = this.options[this.index].id;
				this.activeIndex = this.index;
				options.scrollTop = activeOption.offsetTop - activeOption.offsetHeight * 2;

			} else if (key === "enter" && !this.options[this.index].disabled) {
				e.preventDefault();
				this.selectItem(this.options[this.index].value);
				this.$_Dropdown_close(e);
			} else if (key === "escape" || key === " ") {
				e.preventDefault();
				this.open = false;
			}
		} else if (
			key.indexOf("down") > -1 ||
			key.indexOf("up") > -1 ||
			key === "enter" ||
			key === " "
		) {
			e.preventDefault();
			this.$_SelectDropdown_open(e);
		}
	}

	processValue() {
		if (this.options) {
			const option = this.options.find(o => o.value === this.value);

			if (option) {
				this.value = option.value;
				this.selectedLabel = option.label;
			} else {
				this.value = null;
				this.selectedLabel = null;
			}
		}
	}

	classGen() {
		return {
			[`rbc-dropdown-${this.size}`]:
				this.size && (this.size === "large" || this.size === "small"),
			[`rbc-dropdown-width-${this.sizeWidth}`]: this.sizeWidth,
			disabled: this.disabled && !this.disabled
		};
	}

	heightGen() {
		return (this.height && typeof this.height !== "string") ? `${this.height}px` : this.height;
	}

	activeDescendant() {
		const _self = this;
		if (_self.open) {
			if (_self.options[_self.activeIndex]) {
				let selectedElement = _self.id + "Option" + this.$_Dropdown_updateName(_self.options[_self.activeIndex].value);
				return selectedElement;
			}
		} else {
			if (this.value) {
				return _self.id + "Option" + this.$_Dropdown_updateName(this.value);
			}
		}
	}

	$_Dropdown_updateName(val) {
		return val.toString().replace(/[^\w-]+/g, "-");
	}
}
